import axios from "axios";
import * as APITypes from "../constants/API"
import { encryptValue } from "./encryptValue";

const encryptData = async (data) => {
    // let encrypData = await axios.post(APITypes.CREATE_AGENT_TOKEN, { agent_code: data })
    let value = await encryptValue(data)

    return value ? value : ""
};
export default encryptData;